import React from 'react'
import PageLayout from '../pagelayout';
import OfferList from './offer';
import { ErrorBox } from '../listing';

const OffersPage = () => (
    <PageLayout fullWidth>
        <div>
            <div className="row">
                <div className="col-md-6">
                    <div className="tab-content fade active in min-height">
                        <h3>Ouja offers</h3>
                        <OfferList />
                    </div>
                </div>
                <div className="col-md-6 p-l-0">
                    <div className="tab-content fade active in min-height">
                        <h3>Other offers</h3>
                        <ErrorBox errmsg="No offers found" />
                    </div>
                </div>
            </div>
        </div>
    </PageLayout>
)

export default OffersPage
